import type { IEventBus } from "@/domains/events"
import { WalletConnectedEvent, WalletDisconnectedEvent } from "@/domains/wallet/events"

import type { IVoteStore } from "./interfaces"

export class VoteOrchestrator {
  private walletConnectedHandler: ((event: WalletConnectedEvent) => void) | undefined
  private walletDisconnectedHandler: ((event: WalletDisconnectedEvent) => void) | undefined

  constructor(
    private readonly voteStore: IVoteStore,
    private readonly eventBus: IEventBus,
  ) {}

  initialize() {
    // Subscribe to wallet events
    this.walletConnectedHandler = this.handleWalletConnect.bind(this)
    this.walletDisconnectedHandler = this.handleWalletDisconnect.bind(this)
    this.eventBus.subscribe(WalletConnectedEvent.TYPE, this.walletConnectedHandler)
    this.eventBus.subscribe(WalletDisconnectedEvent.TYPE, this.walletDisconnectedHandler)
  }

  private handleWalletDisconnect(_event: WalletDisconnectedEvent): void {
    // Reset vote store
    this.voteStore.resetVotes()
  }

  private async handleWalletConnect(_event: WalletConnectedEvent): Promise<void> {
    // Reset vote store when wallet connects
    this.voteStore.resetVotes()
  }
}
